(function () {
  function init(root) {
    if (root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';

    var track = root.querySelector('[data-cs-track]');
    var nav = root.querySelector('[data-cs-nav]');
    var prev = root.querySelector('[data-cs-prev]');
    var next = root.querySelector('[data-cs-next]');
    if (!track || !prev || !next) return;

    function step() {
      var slide = track.querySelector('[data-cs-slide]');
      if (!slide) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.offsetWidth + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function toggle(button, off) {
      button.disabled = off;
      button.classList.toggle('is-disabled', off);
      button.setAttribute('aria-disabled', off ? 'true' : 'false');
    }

    function setNav() {
      var max = maxScroll();
      if (nav) nav.hidden = max <= 1;
      toggle(prev, track.scrollLeft <= 1);
      toggle(next, track.scrollLeft >= max - 1);
    }

    function go(delta) {
      var size = step();
      if (!size) return;
      var left = Math.min(maxScroll(), Math.max(0, track.scrollLeft + delta * size));
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    var queued = false;
    function sync() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        setNav();
      });
    }

    prev.addEventListener('click', function (event) {
      event.preventDefault();
      if (!prev.disabled) go(-1);
    });

    next.addEventListener('click', function (event) {
      event.preventDefault();
      if (!next.disabled) go(1);
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    setNav();
  }

  function boot() {
    document.querySelectorAll('[data-community-says]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-community-says]');
    if (!root) return;
    delete root.dataset.csReady;
    init(root);
  });
})();
